import { nullDate } from '../utility'

const TyanDate = {
}

TyanDate.nullDate = nullDate

TyanDate.dateString = d => Ext.Date.format(d !== undefined ? new Date(d) : new Date(), 'Y/m/d')

TyanDate.datetimeString = d => Ext.Date.format(d !== undefined ? new Date(d) : new Date(), 'Y/m/d H:i')

TyanDate.datetimeSecondString = d => Ext.Date.format(d !== undefined ? new Date(d) : new Date(), 'Y/m/d H:i:s')

TyanDate.datetimeFullString = d => Ext.Date.format(d !== undefined ? new Date(d) : new Date(), 'Y/m/d H:i:s.u')

TyanDate.utcToLocal = d => {
	d = d !== undefined ? new Date(d) : new Date()
	return new Date(d.valueOf() + d.getTimezoneOffset() * 60000)
}

TyanDate.localToUtc = d => {
	d = d !== undefined ? new Date(d) : new Date()
	return new Date(d.valueOf() - d.getTimezoneOffset() * 60000)
}

TyanDate.localToUtcValue = d => TyanDate.localToUtc(d).valueOf()

TyanDate.utcToLocalValue = d => TyanDate.utcToLocal(d).valueOf()

TyanDate.getMonth = (d, date, ...args) => {
	d = d !== undefined ? new Date(d) : new Date()
	d.setDate(date === undefined ? 1 : date)
	d.setHours(...args, 0, 0, 0, 0)
	return d
}

TyanDate.getDate = (d, ...args) => {
	d = d !== undefined ? new Date(d) : new Date()
	d.setHours(...args, 0, 0, 0, 0)
	return d
}

TyanDate.getHour = (d, ...args) => {
	d = d !== undefined ? new Date(d) : new Date()
	d.setMinutes(...args, 0, 0, 0)
	return d
}

TyanDate.getMinute = (d, ...args) => {
	d = d !== undefined ? new Date(d) : new Date()
	d.setSeconds(...args, 0, 0)
	return d
}

TyanDate.getSecond = d => {
	d = d !== undefined ? new Date(d) : new Date()
	d.setMilliseconds(0)
	return d
}
TyanDate.dateInfo = (transFn, d, isUtc = false) => {
	d = d !== undefined ? new Date(d) : new Date()
	const { local, utc } = isUtc ? { local: TyanDate.utcToLocal(d), utc: d } : { local: d, utc: TyanDate.localToUtc(d) }

	return transFn ? transFn({
		local,
		localValue: local.valueOf(),
		utc,
		utcValue: utc.valueOf(),
		year: local.getFullYear(),
		month: local.getMonth() + 1,
		date: local.getDate(),
		day: local.getDay(),
		hour: local.getHours(),
		minute: local.getMinutes(),
		second: local.getSeconds(),
		milliseconds: local.getMilliseconds()
	}) : undefined
}

/**
 * 时间差异: d1 - d2，返回指定单位值x的ceil(abs(x))*sign(x)
 * 返回: {millseconds, seconds, minutes, hours, days,}
 */
TyanDate.diff = (d1, d2) => {
	d1 = d1 !== undefined ? new Date(d1) : new Date()
	d2 = d2 !== undefined ? new Date(d2) : new Date()

	const millseconds = d1 - d2
	return millseconds < 0
		? {
			millseconds,
			seconds: Math.floor(millseconds / 1000),
			minutes: Math.floor(millseconds / 60000),
			hours: Math.floor(millseconds / 3600000),
			days: Math.floor(millseconds / 86400000)
		} : {
			millseconds,
			seconds: Math.ceil(millseconds / 1000),
			minutes: Math.ceil(millseconds / 60000),
			hours: Math.ceil(millseconds / 3600000),
			days: Math.ceil(millseconds / 86400000)
		}
}

const periods = ['Month', 'Date', 'Hour', 'Minute', 'Second']
periods.forEach(v => {
	TyanDate[`getCurrent${v}`] = (...args) => TyanDate[`get${v}`](new Date(), ...args)
	TyanDate[`getCurrent${v}Utc`] = (...args) => TyanDate.localToUtc(TyanDate[`getCurrent${v}`](...args))
	TyanDate[`getCurrent${v}UtcValue`] = (...args) => TyanDate.localToUtcValue(TyanDate[`getCurrent${v}`](...args))
	TyanDate[`get${v}Utc`] = (...args) => TyanDate.localToUtc(TyanDate[`get${v}`](...args))
	TyanDate[`get${v}UtcValue`] = (...args) => TyanDate.localToUtcValue(TyanDate[`get${v}`](...args))
	TyanDate[`get${v}Local`] = (d, ...args) => TyanDate[`get${v}`](TyanDate.utcToLocal(d), ...args)
	TyanDate[`get${v}LocalValue`] = (d, ...args) => TyanDate.utcToLocalValue(TyanDate[`get${v}`](TyanDate.utcToLocal(d), ...args))
})

const pluses = [['Year', 'FullYear'], ['Month', 'Month'], ['Date', 'Date'], ['Hour', 'Hours'], ['Minute', 'Minutes'], ['Second', 'Seconds']]
pluses.forEach(([k, v]) => {
	TyanDate[`plus${k}`] = (d, plus = 1) => {
		d = d !== undefined ? new Date(d) : new Date()
		d[`set${v}`](d[`get${v}`]() + plus)
		return d
	}
})

export default TyanDate